import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GuiaEtiquetasPdf from "./GuiaEtiquetasPdf";
import { useState, useEffect } from "react";
import JsBarcode from "jsbarcode";

const GuiaEtiquetasModal = ({ open, onClose, insumos }) => {
  const [data64, setData64] = useState(null);

  useEffect(() => {
    if (!open || !insumos || insumos.length === 0) return;
    setData64(null);

    const internos = insumos.filter((i) => i.internal === true);
    if (internos.length === 0) {
      setData64([]);
      return;
    }

    const buildBarcodes = async () => {
      const result = [];
      for (const item of internos) {
        const barcodeValue = String(item.codigo || item.id || "");
        let dataURL = null;
        if (barcodeValue) {
          try {
            const canvas = document.createElement("canvas");
            JsBarcode(canvas, barcodeValue, {
              format: "CODE128",
              displayValue: true,
              fontSize: 28,
              height: 90,
              width: 2,
              margin: 6,
              background: "#ffffff",
              lineColor: "#000000",
            });
            dataURL = canvas.toDataURL("image/png");
          } catch (e) {
            dataURL = null;
          }
        }
        result.push({ ...item, dataURL });
      }
      setData64(result);
    };

    buildBarcodes();
  }, [open, insumos]);

  return (
    <Dialog fullWidth maxWidth="xl" open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 1.5,
        }}
      >
        <MenuBookIcon sx={{ color: "#fff", fontSize: 22 }} />
        <Typography
          sx={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 700,
            color: "#fff",
            fontSize: "1rem",
          }}
        >
          Guía de Etiquetas — Habilitados Internos (
          {insumos?.filter((i) => i.internal).length || 0})
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        {!data64 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: 6,
              gap: 2,
            }}
          >
            <CircularProgress sx={{ color: "#f43f5e" }} />
            <Typography
              sx={{
                fontFamily: "'Poppins', sans-serif",
                color: "#9ca3af",
                fontSize: "0.85rem",
              }}
            >
              Generando guía de etiquetas...
            </Typography>
          </Box>
        ) : data64.length === 0 ? (
          <Box sx={{ py: 6, textAlign: "center" }}>
            <Typography
              sx={{
                fontFamily: "'Poppins', sans-serif",
                color: "#9ca3af",
                fontSize: "0.9rem",
              }}
            >
              No hay habilitados internos para generar la guía.
            </Typography>
          </Box>
        ) : (
          <GuiaEtiquetasPdf data={data64} />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="secondary"
          variant="contained"
          sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600 }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GuiaEtiquetasModal;
